import { LandingLayoutWithoutSidebar } from "PFApp/components/landing_layout";
import AutoSelect from "PFComponents/select/autoselect";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import OnboardingBox from "../parts/onboarding_box";
import OnboardingHeader from "../parts/onboarding_header";
import { useOnboarding } from "../use_onboarding";
import css from "./common.less";

const TopSkillsStep = () => {
  const { stepDotsProps, currentProfile, saveProfile, navigateNext, navigateBack } =
    useOnboarding("top_skills");
  const { t } = useTranslation("onboarding");

  const skills = currentProfile.skills || [];
  // topSkills are a state rather then just calculated from skills so we can
  // update them separetely from puting to the api so we avoid race condition
  const [topSkills, setTopSkills] = useState(skills.filter((skill) => skill.top));
  const [isLoading, setIsLoading] = useState(false);

  const next = () => {
    setIsLoading(true);
    const skillsToSave = skills.map((skill) => {
      skill.top = !!topSkills.find((other) => other.id === skill.id);
      return skill;
    });
    saveProfile({ skills: skillsToSave }).then(navigateNext);
  };

  const back = () => {
    saveProfile({ registration_status: "details" }); // details are before skills
    navigateBack();
  };

  useEffect(() => {
    skills.length === 0 && navigateNext();
  }, []);

  return (
    <LandingLayoutWithoutSidebar alignTop>
      <OnboardingBox big qaId="Onboarding.TopSkillsStep" stepDotsProps={stepDotsProps} isLoading={isLoading}>
        <OnboardingHeader title={t("coreSkills")} back={back} next={next} />
        <p className={css.tip}>{t("select5Skills")}</p>

        <AutoSelect
          key={JSON.stringify(topSkills.map(({ id }) => id)) /* make the component controlled */}
          letClear
          label={t("coreSkills")}
          maxLength={5}
          placeholder={t("typeSkillHere")}
          multi
          values={topSkills}
          query={(rawTerm) => {
            const normalize = (text = "") => text.toLowerCase().replace(/ /g, "");
            const term = normalize(rawTerm);
            return new Promise((resolve) =>
              resolve(skills.filter(({ text }) => normalize(text).indexOf(term) !== -1))
            );
          }}
          filterOptions={(resp) =>
            resp.filter((option) => !topSkills.find((skill) => +skill.id === +option.id))
          }
          formatOption={(item) => ({
            id: +item.id,
            text: item.text,
            displayElement: item.text,
            item: item
          })}
          handleChange={(newTopSkills) => {
            skills.forEach((skill) => (skill.top = !!newTopSkills.find(({ id }) => id === skill.id)));
            setTopSkills(newTopSkills);
            saveProfile({ skills });
          }}
          tip={t("select5Skills")}
        />
      </OnboardingBox>
    </LandingLayoutWithoutSidebar>
  );
};

export default TopSkillsStep;
